module.exports = __webpack_public_path__ + "static/media/React-NAtive.b1a7c0be.png";